import * as actions from "../action.constants";

const requestGroup = (pageUrl) => ({
  type: actions.REQUEST_GROUP_LIST_SAGA,
  pageUrl,
});

const requestPermissionList = () => ({
  type: actions.REQUEST_PERMISSION_LIST,
});

const requestUserList = () => ({
  type: actions.REQUEST_USER_LIST,
});

const updateAddgroupModal = (data) => ({
  type: actions.SAVE_ADD_GROUP_MODAL_STATUS,
  payload: data,
});

const updateAddgroupModalData = (data) => ({
  type: actions.SAVE_ADD_GROUP_MODAL_DATA,
  payload: data,
});
const sendAddgroupModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_ADD_GROUP_DATA_SAGA,
  payload: data,
  callback,
});
const sendEditGroupModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_EDIT_GROUP_DATA_SAGA,
  payload: data,
  callback,
});
const deleteGroupData = (id, callback) => ({
  type: actions.REQUEST_DELETE_GROUP_SAGA,
  payload: id,
  callback,
});

export {
  requestGroup,
  requestPermissionList,
  requestUserList,
  updateAddgroupModal,
  updateAddgroupModalData,
  sendAddgroupModalData,
  deleteGroupData,
  sendEditGroupModalData,
};
